import { createAction } from '@/utility/actions';

import { SUPERBUNDLE_SUBMIT_FORM, SUPERBUNDLE_GET_RESULTS } from './types';

/**
 * submitSuperbundleForm - data, callback
 */
export const submitSuperbundleForm = createAction(SUPERBUNDLE_SUBMIT_FORM);

/**
 * getSuperbundleResults - params: unique_id
 */
export const getSuperbundleResults = createAction(SUPERBUNDLE_GET_RESULTS);

export default {
  submitSuperbundleForm,
  getSuperbundleResults,
};
